import {
  ChangeEvent,
  Dispatch,
  SetStateAction,
  useMemo,
  useState
} from 'react';
import { ValidationLogic } from './useTextInput';
import i18n from '../../R/string/i18n';
import useSelecter from './useSelecter';

const locationValidationLogics = (): ValidationLogic[] => [
  {
    logic: (location: string) => location.length <= 0,
    msg: i18n.pleaseSelect()
  }
];

function useLocationSelect(
  initVal: string
): [
  string,
  (e: ChangeEvent<HTMLSelectElement>) => void,
  string | undefined,
  Dispatch<SetStateAction<string>>,
  boolean,
  Dispatch<SetStateAction<boolean>>,
  () => void
] {
  const validationLogicsTranslated = locationValidationLogics();
  const [isResetError, setIsResetError] = useState(false);

  const [location, onChangeLocation, locationErr, setLocation, setNotTouched] =
    useSelecter(initVal, validationLogicsTranslated, 1000, i18n.pleaseSelect());

  const hasError = useMemo(
    () =>
      !isResetError &&
      validationLogicsTranslated.some(({ logic }) => logic(location)),
    [location, isResetError]
  );

  const clearError = () => {
    setIsResetError(true);
  };

  return [
    location,
    onChangeLocation,
    locationErr,
    setLocation,
    hasError,
    setNotTouched,
    clearError
  ];
}

export default useLocationSelect;
